import Navbar from "../../components/navbar/index.jsx";
import  './news.css';
import NovoLogo from '../../assets/Selo.jpg';

function News(){
    return  <div>
          <Navbar/>
   
            <div className="container-fluid titulo" >
                

                <div className="bottom">
                     <center> 
                               <img src={NovoLogo} alt="Solaris" style={{ height: "120px", margin: "50px" }} />
                      </center>
                  </div> 

                  <button className="w-100   btn btn-success"  type='button'>
                    <span className='ms-2'>Em Desenvolvimento</span>                  
                </button>
            </div>
    </div>

}
export default News;